import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { fetchRequest } from '@tk/utilities/tk.fetch';

type FollowObject = {
    existing: string;
};

export default class DIWFollow extends TKCustomElementFactory {
    requestUrl?: string;
    existingAttribute: string;
    button?: HTMLButtonElement;

    constructor() {
        super();

        this.requestUrl = this.getAttribute('data-tk-url') || undefined;
        this.existingAttribute = 'data-tk-existing';
        this.button = this.querySelector('[data-tk-trigger]') || undefined;
    }

    connectedCallback(): void {
        if (!this.requestUrl || !this.button) throw new Error('DIWFollow: missing element');

        const action = this.sendRequest.bind(this);

        this.pushListener({ event: 'click', element: this.button, action });
    }

    sendRequest() {
        const payload = {
            existing: this.getAttribute(this.existingAttribute) || '0',
        };

        fetchRequest({
            requestURL: this.requestUrl!,
            resolveHandler: this.changeButton.bind(this),
            payload,
        });
    }

    changeButton(response: TKResponse<FollowObject>) {
        if (!response.success) return;

        const existing = response.dataAsJson.existing;
        this.setAttribute(this.existingAttribute, existing);

        const buttonContent = this.button!.children;

        if (buttonContent.length == 0) return;

        [...buttonContent].forEach((content) => {
            content.classList.toggle('hide');
        });
    }
}
